import React, { Component } from "react";
import moment from "moment";
import { getTimezone } from "../../theme/utils";
import { defaultCountdownFormat } from "../../appConstants";

class Countdown extends Component {
  state = { remainingSeconds: 0 };
  interval = null;

  componentDidMount() {
    this.stop();
    this.setNewDate();
    this.interval = setInterval(this.intervalHandler, 1000);
  }

  componentDidUpdate(prevProps) {
    if (this.props.endDate !== prevProps.endDate) {
      this.setNewDate();
    }
  }

  componentWillUnmount() {
    this.stop();
  }

  intervalHandler = () => {
    const { remainingSeconds } = this.state;
    const { onFinish } = this.props;
    this.setState({ remainingSeconds: remainingSeconds - 1000 }, () => {
      if (Math.floor(remainingSeconds / 1000) === 0) {
        onFinish && onFinish();
        this.stop();
      }
    });
  };

  stop = (interval = this.interval) => clearInterval(interval);

  setNewDate() {
    const { endDate } = this.props;
    const now = new Date();
    const timestampInt = now.getTime() + getTimezone(now);
    const remainingSeconds = new Date(endDate).getTime() - timestampInt;
    this.setState({ remainingSeconds });
  }

  render() {
    const { remainingSeconds } = this.state;
    const { format, prefix } = this.props;
    return (
      <div className={`${prefix}-countdown`}>
        {moment.utc(remainingSeconds > 0 ? remainingSeconds : 0).format(format)}
      </div>
    );
  }
}

Countdown.defaultProps = {
  prefix: "default",
  format: defaultCountdownFormat
};

export default Countdown;



// WEBPACK FOOTER //
// ./src/components/partials/Countdown.js